import React from 'react'
import { Route, IndexRedirect, IndexRoute } from 'react-router'

import App from './components/App'
import Login from './components/Login'

import Teams from './components/sections/Teams'
import TeamDetails from './components/sections/Teams/Details'

import Websites from './components/sections/Websites'
import WebsiteDetails from './components/sections/Websites/Details'

import NewCustomer from './components/sections/NewCustomer'

import Orders from './components/sections/Orders'
import OrderDetails from './components/sections/Orders/Details'
import SignupCode from './components/sections/Orders/SignupCode'

import Trialing from './components/sections/Trialing'

import Transfers from './components/sections/Transfers'

import Reports from './components/sections/Admin/Reports'
import ResellerTeams from './components/sections/Admin/Resellers/Teams'
import ResellerTeamDetails from './components/sections/Admin/Resellers/Teams/Details'
import AddResellerMember from './components/sections/Admin/Resellers/Teams/AddMember'
import AddResellerTeam from './components/sections/Admin/Resellers/Teams/AddTeam'
import MlsList from './components/sections/Admin/Mls'

const notAuthed = auth => {
  return (nextState, replace) => {
    let { location: { state } } = nextState
    if (auth.loggedIn) replace(state && state.return_to || { pathname: '/' })
  }
}

const requireAuth = auth => {
  return (nextState, replace) => {
    if (!auth.loggedIn) replace({ pathname: '/login', state: { return_to: nextState.location } })
  }
}

const requireAdmin = auth => {
  return (nextState, replace) => {
    if (!auth.user.admin) replace({ pathname: '/' })
  }
}

const routes = auth => [
  <Route path="/login" component={Login} onEnter={notAuthed(auth)} />,
  <Route path="/" component={App} onEnter={requireAuth(auth)}>
    <IndexRedirect to="teams" />
    <Route path="teams">
      <IndexRoute component={Teams} />
      <Route path=":team_id" component={TeamDetails} />
    </Route>
    <Route path="websites">
      <IndexRoute component={Websites} />
      <Route path=":website_id" component={WebsiteDetails} />
    </Route>
    <Route path="orders">
      <IndexRoute component={Orders} />
      <Route path="signup_code" component={SignupCode} />
      <Route path=":order_id" component={OrderDetails} />
    </Route>
    <Route path="trialing">
      <IndexRoute component={Trialing} />
    </Route>
    <Route path="transfers">
      <IndexRoute component={Transfers} />
    </Route>
    <Route path="manage">
      <Route path="add-reseller" component={AddResellerMember} />
      <Route path="add-customer" component={NewCustomer} />
    </Route>
    <Route path="admin" onEnter={requireAdmin(auth)}>
      <Route path="mls">
        <IndexRoute component={MlsList} />
        <Route path=":mls_id" component={MlsList} />
      </Route>
      <Route path="reports" component={Reports} />
      <Route path="resellers">
        <IndexRedirect to="teams" />
        <Route path="teams">
          <IndexRoute component={ResellerTeams}/>
          <Route path="add-team" component={AddResellerTeam} />
          <Route path=":reseller_team_id/add-member" component={AddResellerMember} />
          <Route path=":reseller_team_id" component={ResellerTeamDetails} />
        </Route>
      </Route>
      <Route path="add-customer" component={NewCustomer} />
    </Route>
  </Route>
]

export default routes



// WEBPACK FOOTER //
// client/routes.js